import { useCallback } from 'react';
export var useEventProxy = function useEventProxy(children, setOpen) {
  var childrenElement = children;
  var onMouseOver = null;

  if (childrenElement && childrenElement.props && childrenElement.props.onMouseOver) {
    onMouseOver = childrenElement.props.onMouseOver;
  }

  var onMouseOverProxy = useCallback(function (event) {
    setOpen(true);

    if (onMouseOver) {
      onMouseOver(event);
    }
  }, [onMouseOver, setOpen]);
  var onMouseOut = null;

  if (childrenElement && childrenElement.props && childrenElement.props.onMouseOut) {
    onMouseOut = childrenElement.props.onMouseOut;
  }

  var onMouseOutProxy = useCallback(function (event) {
    setOpen(false);

    if (onMouseOut) {
      onMouseOut(event);
    }
  }, [onMouseOut, setOpen]);
  return {
    onMouseOverProxy: onMouseOverProxy,
    onMouseOutProxy: onMouseOutProxy
  };
};